import React, { useState } from 'react';
import '../styles/desktopQRScreen.css';
import { useTranslation } from 'react-i18next';

const BOT_USERNAME = '@Dev_DatumCore_bot';
const BOT_URL = 'https://t.me/Dev_DatumCore_bot';

/**
 * QR-код для https://t.me/Dev_DatumCore_bot.
 * Сгенерирован офлайн (qrencode 4.1.1, ECC level H, версия QR 4 → 33×33 модулей).
 * Высокий уровень коррекции ошибок гарантирует надёжное сканирование с экрана.
 * При смене URL бота нужно перегенерировать вручную.
 */
const QR_VIEWBOX = '0 0 33 33';
const QR_PATH = 'M0,0h1M1,0h1M2,0h1M3,0h1M4,0h1M5,0h1M6,0h1M10,0h1M12,0h1M13,0h1M14,0h1M15,0h1M16,0h1M19,0h1M23,0h1M24,0h1M26,0h1M27,0h1M28,0h1M29,0h1M30,0h1M31,0h1M32,0h1M0,1h1M6,1h1M8,1h1M10,1h1M12,1h1M16,1h1M18,1h1M20,1h1M22,1h1M24,1h1M26,1h1M32,1h1M0,2h1M2,2h1M3,2h1M4,2h1M6,2h1M9,2h1M10,2h1M13,2h1M14,2h1M15,2h1M16,2h1M17,2h1M18,2h1M20,2h1M21,2h1M26,2h1M28,2h1M29,2h1M30,2h1M32,2h1M0,3h1M2,3h1M3,3h1M4,3h1M6,3h1M10,3h1M11,3h1M14,3h1M15,3h1M17,3h1M20,3h1M24,3h1M26,3h1M28,3h1M29,3h1M30,3h1M32,3h1M0,4h1M2,4h1M3,4h1M4,4h1M6,4h1M9,4h1M13,4h1M14,4h1M18,4h1M19,4h1M20,4h1M22,4h1M24,4h1M26,4h1M28,4h1M29,4h1M30,4h1M32,4h1M0,5h1M6,5h1M8,5h1M10,5h1M11,5h1M13,5h1M14,5h1M15,5h1M19,5h1M20,5h1M21,5h1M26,5h1M32,5h1M0,6h1M1,6h1M2,6h1M3,6h1M4,6h1M5,6h1M6,6h1M8,6h1M10,6h1M12,6h1M14,6h1M16,6h1M18,6h1M20,6h1M22,6h1M24,6h1M26,6h1M27,6h1M28,6h1M29,6h1M30,6h1M31,6h1M32,6h1M8,7h1M9,7h1M12,7h1M14,7h1M17,7h1M18,7h1M21,7h1M22,7h1M23,7h1M4,8h1M5,8h1M6,8h1M7,8h1M9,8h1M10,8h1M14,8h1M21,8h1M22,8h1M24,8h1M26,8h1M27,8h1M31,8h1M1,9h1M5,9h1M7,9h1M8,9h1M11,9h1M12,9h1M14,9h1M15,9h1M17,9h1M18,9h1M19,9h1M21,9h1M23,9h1M27,9h1M29,9h1M30,9h1M31,9h1M3,10h1M4,10h1M6,10h1M7,10h1M8,10h1M11,10h1M14,10h1M15,10h1M16,10h1M17,10h1M19,10h1M20,10h1M23,10h1M24,10h1M25,10h1M27,10h1M28,10h1M29,10h1M0,11h1M3,11h1M5,11h1M7,11h1M9,11h1M12,11h1M15,11h1M16,11h1M18,11h1M22,11h1M24,11h1M25,11h1M28,11h1M1,12h1M2,12h1M6,12h1M8,12h1M9,12h1M11,12h1M22,12h1M23,12h1M24,12h1M25,12h1M26,12h1M32,12h1M0,13h1M3,13h1M5,13h1M7,13h1M10,13h1M13,13h1M15,13h1M17,13h1M21,13h1M23,13h1M25,13h1M27,13h1M28,13h1M29,13h1M31,13h1M0,14h1M1,14h1M2,14h1M3,14h1M4,14h1M5,14h1M6,14h1M7,14h1M9,14h1M10,14h1M13,14h1M14,14h1M16,14h1M17,14h1M18,14h1M23,14h1M25,14h1M27,14h1M29,14h1M30,14h1M31,14h1M1,15h1M4,15h1M5,15h1M8,15h1M9,15h1M12,15h1M13,15h1M14,15h1M17,15h1M19,15h1M20,15h1M21,15h1M23,15h1M24,15h1M25,15h1M30,15h1M32,15h1M4,16h1M6,16h1M12,16h1M16,16h1M17,16h1M18,16h1M20,16h1M21,16h1M26,16h1M27,16h1M28,16h1M30,16h1M31,16h1M0,17h1M1,17h1M2,17h1M8,17h1M9,17h1M10,17h1M12,17h1M13,17h1M14,17h1M15,17h1M16,17h1M23,17h1M24,17h1M25,17h1M27,17h1M31,17h1M32,17h1M0,18h1M2,18h1M3,18h1M4,18h1M6,18h1M7,18h1M9,18h1M12,18h1M14,18h1M16,18h1M17,18h1M18,18h1M19,18h1M22,18h1M23,18h1M24,18h1M27,18h1M28,18h1M29,18h1M0,19h1M1,19h1M2,19h1M4,19h1M7,19h1M9,19h1M11,19h1M13,19h1M14,19h1M15,19h1M17,19h1M18,19h1M20,19h1M21,19h1M25,19h1M28,19h1M1,20h1M2,20h1M5,20h1M6,20h1M7,20h1M9,20h1M11,20h1M12,20h1M13,20h1M15,20h1M18,20h1M19,20h1M20,20h1M21,20h1M22,20h1M24,20h1M25,20h1M26,20h1M28,20h1M29,20h1M32,20h1M0,21h1M3,21h1M5,21h1M7,21h1M8,21h1M9,21h1M10,21h1M12,21h1M13,21h1M19,21h1M20,21h1M21,21h1M22,21h1M26,21h1M27,21h1M29,21h1M31,21h1M32,21h1M5,22h1M6,22h1M9,22h1M10,22h1M14,22h1M17,22h1M18,22h1M19,22h1M20,22h1M28,22h1M29,22h1M30,22h1M31,22h1M2,23h1M5,23h1M9,23h1M12,23h1M13,23h1M15,23h1M16,23h1M20,23h1M21,23h1M24,23h1M0,24h1M1,24h1M2,24h1M3,24h1M4,24h1M5,24h1M6,24h1M7,24h1M11,24h1M12,24h1M14,24h1M17,24h1M18,24h1M20,24h1M21,24h1M22,24h1M23,24h1M24,24h1M25,24h1M26,24h1M27,24h1M28,24h1M32,24h1M8,25h1M10,25h1M11,25h1M12,25h1M13,25h1M14,25h1M16,25h1M17,25h1M18,25h1M20,25h1M22,25h1M23,25h1M24,25h1M28,25h1M30,25h1M0,26h1M1,26h1M2,26h1M3,26h1M4,26h1M5,26h1M6,26h1M8,26h1M9,26h1M13,26h1M16,26h1M17,26h1M18,26h1M19,26h1M20,26h1M21,26h1M22,26h1M23,26h1M24,26h1M26,26h1M28,26h1M31,26h1M0,27h1M6,27h1M8,27h1M9,27h1M11,27h1M12,27h1M13,27h1M14,27h1M17,27h1M18,27h1M21,27h1M24,27h1M28,27h1M31,27h1M32,27h1M0,28h1M2,28h1M3,28h1M4,28h1M6,28h1M8,28h1M9,28h1M10,28h1M11,28h1M12,28h1M14,28h1M19,28h1M20,28h1M24,28h1M25,28h1M26,28h1M27,28h1M28,28h1M29,28h1M0,29h1M2,29h1M3,29h1M4,29h1M6,29h1M10,29h1M13,29h1M14,29h1M17,29h1M18,29h1M19,29h1M21,29h1M22,29h1M23,29h1M24,29h1M26,29h1M27,29h1M28,29h1M30,29h1M32,29h1M0,30h1M2,30h1M3,30h1M4,30h1M6,30h1M10,30h1M17,30h1M20,30h1M24,30h1M25,30h1M26,30h1M28,30h1M0,31h1M6,31h1M9,31h1M13,31h1M14,31h1M15,31h1M16,31h1M18,31h1M22,31h1M25,31h1M26,31h1M27,31h1M28,31h1M29,31h1M0,32h1M1,32h1M2,32h1M3,32h1M4,32h1M5,32h1M6,32h1M10,32h1M11,32h1M12,32h1M14,32h1M19,32h1M20,32h1M22,32h1M23,32h1M24,32h1M27,32h1M29,32h1M30,32h1M32,32h1';

/**
 * Полноэкранный экран-заглушка для десктопа и обычного браузера.
 * Показывает QR-код на t.me/Dev_DatumCore_bot, бренд, инструкцию и кнопку Copy.
 *
 * Появляется до запуска авторизации — на десктопе сессия Telegram WebApp
 * недоступна, и попытка играть всё равно не пройдёт.
 */
const DesktopQRScreen = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(BOT_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // clipboard может быть недоступен (HTTP/iframe) — тихо игнорируем
    }
  };

  return (
    <div className="desktop-qr">
      <div className="desktop-qr__glow desktop-qr__glow--violet" aria-hidden="true" />
      <div className="desktop-qr__glow desktop-qr__glow--cyan" aria-hidden="true" />

      <div className="desktop-qr__inner">
        <img
          className="desktop-qr__logo"
          src="/logo.png"
          alt="Datum Empire"
          draggable="false"
        />

        <h1 className="desktop-qr__title">{t('desktop.title', 'Get Datum on Your Mobile')}</h1>
        <p className="desktop-qr__subtitle">
          {t('desktop.subtitle', 'Datum Empire is a mobile-first Telegram game.')}
        </p>

        <div className="desktop-qr__card">
          <div className="desktop-qr__qr-frame">
            <svg
              viewBox={QR_VIEWBOX}
              className="desktop-qr__qr"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label={t('desktop.qr_aria', 'QR code linking to {{url}}', { url: BOT_URL })}
            >
              <rect x="0" y="0" width="33" height="33" fill="#ffffff" />
              <path
                stroke="#0a0820"
                strokeWidth="1"
                transform="translate(0,0.5)"
                d={QR_PATH}
              />
            </svg>
          </div>

          <a
            className="desktop-qr__username"
            href={BOT_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {BOT_USERNAME}
          </a>
        </div>

        <p className="desktop-qr__hint">
          {t('desktop.hint', 'Point your phone camera at the QR code to open the game in Telegram.')}
        </p>

        <button
          type="button"
          className={`desktop-qr__copy${copied ? ' desktop-qr__copy--ok' : ''}`}
          onClick={handleCopy}
        >
          <span className="desktop-qr__copy-icon" aria-hidden="true">
            {copied ? (
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="12" height="12" rx="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
              </svg>
            )}
          </span>
          <span>{copied ? t('desktop.copied', 'Link copied') : t('desktop.copy', 'Copy link')}</span>
        </button>
      </div>
    </div>
  );
};

export default DesktopQRScreen;
